import { Component, inject, HostListener } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppService } from './services/app.service';


@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    providers: []
})
export class AppComponent {
  title = 'cbwidget';
  apps = inject(AppService);


  
  @HostListener('window:message', ['$event'])
  onMessage(event:any) {
    if (this.apps.bas.envtest) console.log("onMessage", event)
    let ev = this.apps.bas.es.onMessage(event);
    
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?:any) {
    //if (this.apps.bas.envtest) console.log("onResize")
    this.apps.bas.ui.onResize(event);
  }


}
